import { render, staticRenderFns } from "./PanelAccountSettingsWeb.vue?vue&type=template&id=5440639e&scoped=true&"
import script from "./PanelAccountSettingsWeb.vue?vue&type=script&lang=js&"
export * from "./PanelAccountSettingsWeb.vue?vue&type=script&lang=js&"
import style0 from "./PanelAccountSettingsWeb.vue?vue&type=style&index=0&id=5440639e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5440639e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5440639e')) {
      api.createRecord('5440639e', component.options)
    } else {
      api.reload('5440639e', component.options)
    }
    module.hot.accept("./PanelAccountSettingsWeb.vue?vue&type=template&id=5440639e&scoped=true&", function () {
      api.rerender('5440639e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PanelAccountSettingsWeb.vue"
export default component.exports